Promise.all([
  import(/* webpackMode: "eager" */ './deals-widget.scss'),
  import('../../scripts/dbs/dbs.utilities.geolocation'),
  import('../../plugins/semantic/modal.scss'),
  import('../../plugins/semantic/modal'),
  import('../../plugins/semantic/dimmer.scss'),
  import('../../plugins/semantic/dimmer'),
  import('../../plugins/semantic/loader.css'),
]).then(() => {
  $('.widget.deals-widget').each(function (i, el) {
    $(el).data('widget', new DealsWidget(el))
    $(el).data('widget').init()
  })
  
  // Debug function for testing deals-widget modal
  window.debugDealsModal = function() {
    console.log('=== DEALS WIDGET MODAL DEBUG ===')
    const dealsWidgets = $('.widget.deals-widget')
    console.log('Deals widgets found:', dealsWidgets.length)
    
    dealsWidgets.each(function(i, widget) {
      const $widget = $(widget)
      const modal = $widget.find('.terms-popup')
      const expanders = $widget.find('.expander')
      console.log(`Widget ${i}:`, 'Modal:', modal.length, 'Expanders:', expanders.length)
      
      if (modal.length) {
        console.log('Testing modal with sample content...')
        modal.find('.content').html('<h2>Debug Test</h2><p>This is a test from the deals-widget debug function.</p>')
        modal.find('.content').scrollTop(0)
        
        if (window.innerWidth <= 767) {
          // Mobile slide animation
          modal.css({
            'display': 'none',
            'transform': 'translateY(100%)',
            'transition': 'none'
          })
          modal.removeClass('visible active')
          modal.css('display', 'flex')
          modal.addClass('visible active')
          modal[0].offsetHeight
          
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              modal.css({
                'transition': 'transform 0.3s ease',
                'transform': 'translateY(0)'
              })
              console.log('Debug: Mobile slide animation triggered')
            })
          })
        } else {
          // Desktop modal
          modal.modal('show')
        }
        return false // Exit after first modal test
      }
    })
  }
  
  console.log('Debug function added: Call window.debugDealsModal() to test deals widget modal')
})

function DealsWidget(el) {
  const self = this
  self.el = $(el)
  self.deals = require('./deals.hbs')
  self.latitude = null
  self.longitude = null

  self.showDeals = function (location, offset) {
    const delimitedCategories = self.el.attr('data-categories')
    const count = self.el.attr('data-loadlimit')
    const displayType = self.el.attr('data-display-type')

    let apiUrl = $(el).attr('data-endpoint-nearby')

    if (location.indexOf('statetab') != -1) {
      apiUrl = $(el).attr('data-endpoint-state')
    }

    $.ajax({
      url: apiUrl,
      type: $(el).attr('data-method'),
      data: JSON.stringify({
        displaytype: displayType,
        categories: delimitedCategories,
        location: location,
        offset: offset,
        count: count,
        latitude: self.latitude,
        longitude: self.longitude,
      }),
      dataType: 'json',
      contentType: 'application/json',
    })
      .done(function (data) {
        // switch tab from nearby to featured
        if (data.Location.toLowerCase() === 'nearby') {
          self.el.find('.switchable').html('Nearby')
        }
        if (data.Location.toLowerCase() === 'featured') {
          self.el.find('.switchable').html('Featured')
        }

        // decide what tab to render results in
        let tab = data.Location.toLowerCase()
        if (data.Location.toLowerCase() === 'nearby' || data.Location.toLowerCase() === 'featured') {
          tab = 'firsttab'
        }

        self.el.find('.deal-container[data-deal="' + tab + '"] .load-more').removeClass('loading')
        // $.fn.matchHeight._update();

        if (data.Deals != null && data.Deals.length) {
          const html = self.deals(data)

          if (self.el.find('.tab[data-deal="' + tab + '"]').hasClass('loaded')) {
            self.el.find('.deal-container[data-deal="' + tab + '"] .deals').append(html)
          } else {
            self.el.find('.deal-container[data-deal="' + tab + '"] .deals').html(html)
          }

          // load more
          if (parseInt(data.TotalCount) > parseInt(data.Offset) + parseInt(data.PageSize)) {
            self.el.find('.deal-container[data-deal="' + tab + '"] .button-container').show()
          } else {
            self.el.find('.deal-container[data-deal="' + tab + '"] .button-container').hide()
          }

          // update offset
          const newOffset = parseInt(data.Offset) + parseInt(data.PageSize)
          self.el.find('.tab[data-deal="' + tab + '"]').attr('data-offset', newOffset)
          // self.el.find('.main-container').matchHeight();
          // $.fn.matchHeight._update();
        } else {
          if (data.Message && data.Message.length) {
            $('<div class="message">' + data.Message + '</div>').insertBefore(
              self.el.find('.deal-container[data-deal="' + tab + '"] .deals'),
            )
            self.el.find('.deal-container[data-deal="' + tab + '"] .deals .loader').removeClass('active')
          } else {
            self.el.find('.deal-container[data-deal="' + tab + '"] .message').remove()
          }
          // $.fn.matchHeight._update();
        }

        self.el.find('.tab[data-deal="' + tab + '"]').addClass('loaded')
        // $.fn.matchHeight._update();
      })
      .fail(function () {
        // TODO decide what happens on fail
      })
  }

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('DealsWidget init', self)
    }

    self.geo = new dbs.utilities.geolocation()
    self.geo.events.subscribe('Geolocation:getPosition_error', function () {
      self.showDeals(firsttab, 0)
    })
    self.geo.events.subscribe('Geolocation:getPosition_response', function (response) {
      self.latitude = response.coords.latitude
      self.longitude = response.coords.longitude
      self.showDeals(firsttab, 0)
    })
    self.geo.getPosition()

    self.el.css('opacity', 1)
    self.termsModal = self.el.find('.terms-popup').modal()

    const firsttab = self.el.find('.tab:first').attr('data-deal')

    $('body').on('click', '.deals-widget .deals .deal .terms .expander', function (e) {
      e.preventDefault()
      console.log('Deals-widget expander clicked:', this)
      
      // Find the modal within the same deals-widget
      const modal = $(this).closest('.deals-widget').find('.terms-popup')
      const contentHtml = $(this).siblings('.content').html()
      
      console.log('Modal found:', modal.length, 'Content found:', !!contentHtml)
      
      if (modal.length && contentHtml) {
        modal.find('.content').html(contentHtml)
        
        // Reset scroll position to top
        modal.find('.content').scrollTop(0)
        
        // Use custom slide animation for mobile
        if (window.innerWidth <= 767) {
          console.log('Deals-widget: Mobile detected, using custom slide animation')
          
          // Ensure dimmer is shown
          $('.ui.dimmer.modals').addClass('visible active').show()
          $('body').addClass('dimmable dimmed')
          
          // Step 1: Ensure modal is completely hidden and positioned off-screen
          modal.css({
            'display': 'none',
            'transform': 'translateY(100%)',
            'transition': 'none'
          })
          modal.removeClass('visible active animating')
          
          // Step 2: Show modal but keep it off-screen
          modal.css('display', 'flex')
          modal.addClass('visible active')
          
          // Step 3: Force a reflow to ensure off-screen position is rendered
          modal[0].offsetHeight
          
          // Step 4: Enable transition and slide up on next frame
          requestAnimationFrame(() => {
            requestAnimationFrame(() => { // Double requestAnimationFrame for robust timing
              modal.css({
                'transition': 'transform 0.3s ease',
                'transform': 'translateY(0)'
              })
              console.log('Deals-widget: Slide animation triggered')
              
              // Debug current state
              setTimeout(() => {
                console.log('Deals-widget: Animation state check:')
                console.log('- Modal display:', modal.css('display'))
                console.log('- Modal transform:', modal.css('transform'))
                console.log('- Modal classes:', modal.attr('class'))
                console.log('- Modal visible:', modal.is(':visible'))
              }, 100)
            })
          })
        } else {
          // Desktop - use normal Semantic UI modal
          modal.modal('show')
        }
      } else {
        console.error('Deals-widget: Modal or content not found. Modal:', modal.length, 'Content:', !!contentHtml)
      }
    })

    self.el.find('.tabs .tab').click(function (event) {
      event.preventDefault()
      $(this).addClass('active').siblings().removeClass('active')
      self.el.find('.deal-container').removeClass('active')
      self.el.find('.deal-container[data-deal="' + $(this).attr('data-deal') + '"]').addClass('active')

      if (!$(this).hasClass('loaded')) {
        let offset = 0
        if ($(this).attr('data-offset')) {
          offset = parseInt($(this).attr('data-offset'))
        }
        self.showDeals($(this).attr('data-deal'), offset)
      }

      // setTimeout(function(){
      //   $.fn.matchHeight._update();
      // }, 1000);
    })

    self.el.find('.load-more').click(function (event) {
      event.preventDefault()

      if (!$(this).hasClass('loading')) {
        // decide what tab to render results in
        const tab = $(this).parents('.deal-container').attr('data-deal')
        const offset = parseInt(self.el.find('.tab[data-deal="' + tab + '"]').attr('data-offset'))
        self.showDeals(tab, offset)
      }

      $(this).addClass('loading')
    })
  }
}
